// TODO: Import React module
import React, { useState, useEffect, useRef } from 'react';

// TODO: Import MUI module
import { Box, CircularProgress, IconButton, Paper, Slider, Stack, Typography, } from '@mui/material';

// TODO: Import MUI icon
import { Pause, PlayArrow, SkipPrevious, SkipNext, Speed, } from '@mui/icons-material';

// TODO: Import context
import { Context, } from '../../Common/Context';
import { Text } from '../../Common/Text';

// TODO: Import custom component

const Timelapse = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component Timelapse Rendered');

    // TODO: Define useContext
    const { language } = React.useContext(Context);

    // TODO: Define variable
    const speedOptions = [0.5, 1, 2, 4, 8];

    const [data, setData] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [playbackSpeed, setPlaybackSpeed] = useState(8);
    const [loading, setLoading] = useState(true);
    const intervalRef = useRef(null);
    const imageBaseUrl = 'https://www.pohtyh.edu.hk/Files/CampusDevelopment/BlessedBotanicals/Timelapse/';

    // TODO: Define event
    const getData = () => {
        (async () => {
            const formData = new FormData();
            formData.append('action', 'GetImages');

            fetch(
                'https://www.pohtyh.edu.hk/MyTYH5/webservices/EGarden.php',
                { method: 'POST', body: formData, }
            )
                .then((response) => response.json())
                .then((result) => {
                    if (result) {
                        console.log('GetImages:', 'Data received');
                        setData(result);
                        setCurrentIndex(0);
                    } else {
                        console.log('GetImages:', 'Can not get data');
                    }

                    setLoading(false);
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        })();
    }

    const handleSliderChange = (event, newValue) => {
        setCurrentIndex(newValue);
        if (isPlaying) {
            setIsPlaying(false);
        }
    };

    const formatTime = (index) => {
        if (!data || !data.images[index]) return '';
        const filename = data.images[index];
        // Remark: Filename format as YYYYMMDDHHmmss.jpg
        const dateStr = filename.substring(0, 12);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const hour = dateStr.substring(8, 10);
        const minute = dateStr.substring(10, 12);

        return `${day}/${month} ${hour}:${minute}`;
    };

    useEffect(getData, []);

    useEffect(() => {
        if (isPlaying) {
            intervalRef.current = setInterval(() => {
                setCurrentIndex(prev => (prev + 1) % (data?.images.length || 1));
            }, 1000 / playbackSpeed);
        } else {
            clearInterval(intervalRef.current);
        }

        return () => clearInterval(intervalRef.current);
    }, [isPlaying, playbackSpeed, data]);

    // TODO: Return component
    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                <CircularProgress />
            </Box>
        );
    };

    if (!data) {
        return (
            <Typography variant="h6" align="center" mt={4}>
                {Text.Common.Loading[language]}
            </Typography>
        );
    };

    return (
        <Box id="Timelapse" sx={{ py: 4, }}>
            <Typography
                align="center"
                gutterBottom
                sx={{ color: 'success.dark', fontWeight: 'bold', textAlign: 'center', }}
                variant="h4"
            >
                {Text.CampusDevelopment.BlessedBotanicals.Timelapse.Title[language]}
            </Typography>
            <Paper elevation={3} sx={{ p: 2, maxWidth: 1, mx: 'auto' }}>
                <Box sx={{ mb: 2 }}>
                    <Box
                        sx={{
                            width: '100%',
                            aspectRatio: '16/9',
                            backgroundColor: 'black',
                            mb: 2,
                            maxWidth: 1,
                            mx: 'auto',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            overflow: 'hidden'
                        }}
                    >
                        {data.images[currentIndex] && (
                            <img
                                src={`${imageBaseUrl}${data.images[currentIndex]}`}
                                alt={`CCTV ${formatTime(currentIndex)}`}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    background: 'black'
                                }}
                            />)}
                    </Box>
                    <Box sx={{ px: 2 }}>
                        <Slider
                            value={currentIndex}
                            onChange={handleSliderChange}
                            min={0}
                            max={data.images.length - 1}
                            step={1}
                            marks={[
                                { value: 0, label: data.first },
                                { value: data.images.length - 1, label: data.last }
                            ]}
                            sx={{
                                '& .MuiSlider-markLabel': {
                                    fontSize: '0.75rem',
                                    mt: 1
                                }
                            }}
                        />
                    </Box>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Stack direction="row" spacing={1} alignItems="center">
                            <IconButton
                                onClick={() => setCurrentIndex(0)}
                                disabled={currentIndex === 0}
                            >
                                <SkipPrevious />
                            </IconButton>
                            <IconButton
                                onClick={() => setIsPlaying(!isPlaying)}
                                color="primary"
                                size="large"
                            >
                                {isPlaying ? <Pause fontSize="large" /> : <PlayArrow fontSize="large" />}
                            </IconButton>
                            <IconButton
                                onClick={() => setCurrentIndex(data.images.length - 1)}
                                disabled={currentIndex === data.images.length - 1}
                            >
                                <SkipNext />
                            </IconButton>
                            <Box display="flex" alignItems="center" ml={2}>
                                <Speed color="action" sx={{ mr: 1 }} />
                                <select
                                    value={playbackSpeed}
                                    onChange={(e) => setPlaybackSpeed(parseFloat(e.target.value))}
                                    style={{ padding: 1.5, borderRadius: 1, border: '1px solid #ccc' }}
                                >
                                    {speedOptions.map(speed => (
                                        <option key={speed} value={speed}>
                                            {speed}x
                                        </option>
                                    ))}
                                </select>
                            </Box>
                        </Stack>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default Timelapse;